import Vue from "vue"
import Vuex from "vuex"

import client from "@/lib/ApiClient"
import { toTitleCase } from "@/utils"
import { classifyValidationScore } from "@osteon-nexus-connect-lib/nc-frontend"

function getScanAnalysis(validateScansResponse) {
  const scanAnalysis = {
    scoreImmediate: validateScansResponse.scanAnalysis.scoreImmediate,
    scoreRestorative: validateScansResponse.scanAnalysis.scoreRestorative,
    scanGaugeComparisons: [],
    narrowScanBodyComparisons: []
  }
  validateScansResponse.scanAnalysis.scanGaugeComparisons.forEach(c => 
    scanAnalysis.scanGaugeComparisons.push({
      scoreImmediate: c.scoreImmediate,
      scoreRestorative: c.scoreRestorative,
    })
  )
  validateScansResponse.scanAnalysis.narrowScanBodyComparisons.forEach(c => 
    scanAnalysis.narrowScanBodyComparisons.push({
      pass: c.pass,
    })
  )
  return scanAnalysis
}

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    orderUid: null,
    orderDetails: {
      kit_box_id: null,
      patient_reference: null,
      session_type: null,
      dentate: null
      // upper_options: {
      // order_session_uid: null,
      // nc_session_id: null,
      // responses: null,
      // }
      // client_uid: null,
      // assigned: true
      // submitted_at: null
    },
    questions: null,
    existingPatient: null,
    currentStepIndex: 1,

    settings: null,
    accessToken: null,
    country: null,
    pageState: [{ cols: 7, component: "ConnectBranding" }],
    client: null,
    transition: null,

    upperAddScansResponse: null,
    lowerAddScansResponse: null,
    upperValidateScansResponse: null,
    lowerValidateScansResponse: null,
    upperUploadedScans: [],
    lowerUploadedScans: [],
    upperAdditionalFiles: [],
    lowerAdditionalFiles: [],

    retrying: false,
    retryCount: 0,
    faceCount: null,
    scanBodySelectionLabel: null,
    narrowScanBodiesPresent: false,

    errorMessage: null
  },
  getters: {
    currentStepIndex: (state) => state.currentStepIndex,
    orderUid: (state) => state.orderUid,
    orderSessionUid: (state) => state.orderSessionUid,
    orderDetails: (state) => state.orderDetails,
    questions: (state) => state.questions,
    existingPatient: (state) => state.existingPatient,
    settings: (state) => state.settings,
    accessToken: (state) => state.accessToken,
    country: (state) => state.country,
    pageState: (state) => state.pageState,
    scanValidationScore: (state) => state.scanValidationScore,
    client: (state) => state.client,
    transition: (state) => state.transition,
    retrying: (state) => state.retrying,
    retryCount: (state) => state.retryCount,
    faceCount: (state) => state.faceCount,
    narrowScanBodiesPresent: (state) => state.narrowScanBodiesPresent,
    scanBodySelectionLabel: (state) => state.scanBodySelectionLabel,
    upperAddScansResponse: (state) => state.upperAddScansResponse,
    lowerAddScansResponse: (state) => state.lowerAddScansResponse,
    upperValidateScansResponse: (state) => state.upperValidateScansResponse,
    lowerValidateScansResponse: (state) => state.lowerValidateScansResponse,
    upperUploadedScans: (state) => state.upperUploadedScans,
    lowerUploadedScans: (state) => state.lowerUploadedScans,
    upperAdditionalFiles: (state) => state.upperAdditionalFiles,
    lowerAdditionalFiles: (state) => state.lowerAdditionalFiles,
    upperValidationOutcome: (state) => {
      if (!state.upperValidateScansResponse) return
      return classifyValidationScore(
        state.upperValidateScansResponse,
        state.orderDetails.session_type === "immediate"
      )
    },
    upperScanAnalysis: (state) => {
      if (!state.upperValidateScansResponse) return
      return getScanAnalysis(state.upperValidateScansResponse)
    },
    lowerValidationOutcome: (state) => {
      if (!state.lowerValidateScansResponse) return
      return classifyValidationScore(
        state.lowerValidateScansResponse,
        state.orderDetails.session_type === "immediate"
      )
    },
    lowerScanAnalysis: (state) => {
      if (!state.lowerValidateScansResponse) return
      return getScanAnalysis(state.lowerValidateScansResponse)
    },
    errorMessage: (state) => state.errorMessage
  },
  mutations: {
    SET_CURRENT_STEP_INDEX(state, payload) {
      state.currentStepIndex = payload
    },
    SET_ORDER_UID(state, payload) {
      state.orderUid = payload
    },
    SET_ORDER_SESSION_UID(state, payload) {
      state.orderSessionUid = payload
    },
    SET_ORDER_DETAILS(state, payload) {
      state.orderDetails = payload
    },
    SET_QUESTIONS(state, payload) {
      state.questions = payload
    },
    SET_EXISTING_PATIENT(state, payload) {
      state.existingPatient = payload
    },
    SET_SETTINGS(state, payload) {
      state.settings = payload
    },
    SET_ACCESS_TOKEN(state, payload) {
      state.accessToken = payload
    },
    SET_COUNTRY(state, payload) {
      state.country = payload
      client.oft.setCountry(payload)
    },
    SET_PAGE_STATE(state, payload) {
      state.pageState = payload
    },
    SET_SCAN_VALIDATION_SCORE(state, payload) {
      state.scanValidationScore = payload
    },
    SET_CLIENT(state, payload) {
      state.client = payload
    },
    SET_TRANSITION(state, payload) {
      state.transition = payload
    },
    SET_NARROW_SCAN_BODIES_PRESENT(state, payload) {
      state.narrowScanBodiesPresent = payload
    },
    SET_SCAN_BODY_SELECTION_LABEL(state, payload) {
      state.scanBodySelectionLabel = payload
    },
    SET_UPPER_ADD_SCANS_RESPONSE(state, payload) {
      state.upperAddScansResponse = payload
    },
    SET_UPPER_VALIDATE_SCANS_RESPONSE(state, payload) {
      state.upperValidateScansResponse = payload
    },
    SET_UPPER_ADDITIONAL_FILES(state, payload) {
      state.upperAdditionalFiles = payload
    },
    SET_UPPER_UPLOADED_SCANS(state, payload) {
      state.upperUploadedScans = payload
    },
    SET_LOWER_ADD_SCANS_RESPONSE(state, payload) {
      state.lowerAddScansResponse = payload
    },
    SET_LOWER_VALIDATE_SCANS_RESPONSE(state, payload) {
      state.lowerValidateScansResponse = payload
    },
    SET_LOWER_ADDITIONAL_FILES(state, payload) {
      state.lowerAdditionalFiles = payload
    },
    SET_LOWER_UPLOADED_SCANS(state, payload) {
      state.lowerUploadedScans = payload
    },
    SET_MODEL_SCAN(state, payload) {
      state.modelScan = payload
    },
    SET_RETRYING(state, payload) {
      state.retrying = payload
    },
    SET_RETRY_COUNT(state, payload) {
      state.retryCount = payload
    },
    SET_FACE_COUNT(state, payload) {
      state.faceCount = payload
    },
    SET_ERROR_MESSAGE(state, payload) {
      state.errorMessage = payload
    }
  },
  actions: {
    setCurrentStepIndex({ commit }, payload) {
      commit("SET_CURRENT_STEP_INDEX", payload)
    },
    setOrderUid({ commit }, payload) {
      commit("SET_ORDER_UID", payload)
    },
    setOrderSessionUid({ commit }, payload) {
      commit("SET_ORDER_SESSION_UID", payload)
    },
    setOrderDetails({ commit }, payload) {
      commit("SET_ORDER_DETAILS", payload)
    },
    setQuestions({ commit }, payload) {
      commit("SET_QUESTIONS", payload)
    },
    setExistingPatient({ commit }, payload) {
      commit("SET_EXISTING_PATIENT", payload)
    },
    setSettings({ commit }, payload) {
      commit("SET_SETTINGS", payload)
    },
    setAccessToken({ commit }, payload) {
      commit("SET_ACCESS_TOKEN", payload)
    },
    setCountry({ commit }, payload) {
      commit("SET_COUNTRY", payload)
    },
    setPageState({ commit }, payload) {
      commit("SET_PAGE_STATE", payload)
    },
    setScanValidationScore({ commit }, payload) {
      commit("SET_SCAN_VALIDATION_SCORE", payload)
    },
    setClient({ commit }, payload) {
      commit("SET_CLIENT", payload)
    },
    setTransition({ commit }, payload) {
      commit("SET_TRANSITION", payload)
    },
    setNarrowScanBodiesPresent({ commit }, payload) {
      commit("SET_NARROW_SCAN_BODIES_PRESENT", payload)
    },
    setScanBodySelectionLabel({ commit }, payload) {
      commit("SET_SCAN_BODY_SELECTION_LABEL", payload)
    },
    setUpperAddScansResponse({ commit }, payload) {
      commit("SET_UPPER_ADD_SCANS_RESPONSE", payload)
    },
    setUpperValidateScansResponse({ commit }, payload) {
      commit("SET_UPPER_VALIDATE_SCANS_RESPONSE", payload)
    },
    setUpperAdditionalFiles({ commit }, payload) {
      commit("SET_UPPER_ADDITIONAL_FILES", payload)
    },
    setUpperUploadedScans({ commit }, payload) {
      commit("SET_UPPER_UPLOADED_SCANS", payload)
    },
    setLowerAddScansResponse({ commit }, payload) {
      commit("SET_LOWER_ADD_SCANS_RESPONSE", payload)
    },
    setLowerValidateScansResponse({ commit }, payload) {
      commit("SET_LOWER_VALIDATE_SCANS_RESPONSE", payload)
    },
    setLowerAdditionalFiles({ commit }, payload) {
      commit("SET_LOWER_ADDITIONAL_FILES", payload)
    },
    setLowerUploadedScans({ commit }, payload) {
      commit("SET_LOWER_UPLOADED_SCANS", payload)
    },
    setModelScan({ commit }, payload) {
      commit("SET_MODEL_SCAN", payload)
    },
    setRetrying({ commit }, payload) {
      commit("SET_RETRYING", payload)
    },
    setRetryCount({ commit }, payload) {
      commit("SET_RETRY_COUNT", payload)
    },
    setFaceCount({ commit }, payload) {
      commit("SET_FACE_COUNT", payload)
    },
    setErrorMessage({ commit }, payload) {
      commit("SET_ERROR_MESSAGE", payload)
    },
    clearForDentate({ dispatch }) {
      dispatch("setNarrowScanBodiesPresent", false)
      dispatch("setScanBodySelectionLabel", "Scan Gauges")
      dispatch("setFaceCount", null)
      dispatch("setRetryCount", 0)
      dispatch("setRetrying", false)
    },
    resetForDentate({ dispatch, getters }, dentate, lgAndUp) {
      dispatch("clearForDentate")

      const orderDetails = {
        ...getters.orderDetails
      }
      if (dentate)
        orderDetails[`${dentate}_options`] = {
          ...getters.orderDetails[`${dentate}_options`],
          nc_session_id: null
        }

      dispatch("setOrderDetails", orderDetails)
      dispatch(`set${toTitleCase(dentate)}AddScansResponse`, null)
      dispatch(`set${toTitleCase(dentate)}ValidateScansResponse`, null)
      dispatch(`set${toTitleCase(dentate)}AdditionalFiles`, [])
      dispatch(`set${toTitleCase(dentate)}UploadedScans`, [])
      dispatch("setPageState", [
        { cols: lgAndUp ? 7 : 5, component: "ConnectBranding" }
      ])
    },
    restartSession({ dispatch }, lgAndUp) {
      dispatch("clearForDentate")
      dispatch("setExistingPatient", false)
      dispatch("setUpperAddScansResponse", null)
      dispatch("setUpperValidateScansResponse", null)
      dispatch("setUpperUploadedScans", [])
      dispatch("setUpperAdditionalFiles", [])
      dispatch("setLowerAddScansResponse", null)
      dispatch("setLowerValidateScansResponse", null)
      dispatch("setLowerUploadedScans", [])
      dispatch("setLowerAdditionalFiles", [])
      dispatch("setPageState", [
        { cols: lgAndUp ? 7 : 5, component: "ConnectBranding" }
      ])
    },
    newSession({ dispatch, getters }, lgAndUp) {
      dispatch("restartSession", lgAndUp)
      dispatch("setOrderUid", null)
      const orderDetails = {
        kit_box_id: null,
        patient_reference: null,
        session_type: null,
        dentate: null,
        assigned: true
      }
      if (getters.settings.manage_clients)
        orderDetails.client_uid = getters.client.uid
      dispatch("setOrderDetails", orderDetails)
      dispatch("setQuestions", null)
      dispatch("setPageState", [
        { cols: lgAndUp ? 7 : 5, component: "ConnectBranding" }
      ])
      dispatch("setCurrentStepIndex", 1)
    }
  },
  modules: {}
})
